/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TypeObjectKeyValuePair model module.
 * @module model/TypeObjectKeyValuePair
 * @version V1
 */
class TypeObjectKeyValuePair {
    /**
     * Constructs a new <code>TypeObjectKeyValuePair</code>.
     * @alias module:model/TypeObjectKeyValuePair
     */
    constructor() { 
        
        TypeObjectKeyValuePair.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>TypeObjectKeyValuePair</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TypeObjectKeyValuePair} obj Optional instance to populate.
     * @return {module:model/TypeObjectKeyValuePair} The populated <code>TypeObjectKeyValuePair</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TypeObjectKeyValuePair();

            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], Object);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TypeObjectKeyValuePair</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TypeObjectKeyValuePair</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}



/**
 * @member {String} key
 */
TypeObjectKeyValuePair.prototype['key'] = undefined;

/**
 * @member {Object} value
 */
TypeObjectKeyValuePair.prototype['value'] = undefined;






export default TypeObjectKeyValuePair;

